import { LocationError } from 'src/app/core/models/reports/error-reports.model';

export const LOCATION_ERROR_CONSTS = {
  HEADER: $localize`Location Error Report`,
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
  DATE_LABEL: $localize`Date`,
};

export const FILE_NAME = 'Location-Error-Report';

export const LOCATION_ERROR_PDF_REPORT = {
  NAME: 'Location Error Report',
  COLUMNS: [
    'timeStamp'.toUpperCase(),
    'Location'.toUpperCase(),
    'Loop'.toUpperCase(),
    'ErrorMessage'.toUpperCase(),
    'DeviceName'.toUpperCase(),
    'TrackNo'.toUpperCase(),
    'ScanCode'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'timeStamp',
    'location',
    'loop',
    'errorMessage',
    'deviceName',
    'trackNo',
    'scanCode',
  ] as (keyof LocationError)[],
};
